import { generateId } from '@freelancer/datastore/testing/helpers';
import { isDefined } from '@freelancer/utils';
import type {
  BidVectorSearchAnnotation,
  BidVectorSearchAnnotationSegment,
} from './bid-vector-search-annotations.model';

export interface GenerateBidVectorSearchAnnotationOptions {
  readonly id?: number;
  readonly bidId?: number;
  readonly text?: string;
  readonly segments?: readonly BidVectorSearchAnnotationSegment[];
}

export interface GenerateBidVectorSearchAnnotationsOptions {
  readonly bidIds: readonly number[];
  readonly annotations: readonly Exclude<
    GenerateBidVectorSearchAnnotationOptions,
    'id'
  >[];
}

export function generateBidVectorSearchAnnotationObject({
  id = generateId(),
  bidId = generateId(),
  text = 'Has a strong portfolio and excellent reviews.',
  segments = [
    {
      text: 'strong portfolio',
      context: {
        id: 1,
        type: 'showcase',
      },
    },
  ],
}: GenerateBidVectorSearchAnnotationOptions): BidVectorSearchAnnotation {
  return {
    id,
    bidId,
    text,
    segments,
  };
}

export function generateBidVectorSearchAnnotationObjects({
  bidIds,
  annotations,
}: GenerateBidVectorSearchAnnotationsOptions): readonly BidVectorSearchAnnotation[] {
  return bidIds
    .map((bidId, index) => {
      const annotation = annotations.at(index);

      if (annotation === undefined) {
        return undefined;
      }

      return generateBidVectorSearchAnnotationObject({
        bidId,
        ...annotation,
      });
    })
    .filter(isDefined);
}
